var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#D7C0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.1687V7.5C6.5 7.36739 6.55273 7.24022 6.64648 7.14645C6.74023 7.05267 6.86743 7 7 7H17C17.1326 7 17.2598 7.05267 17.3535 7.14645C17.4473 7.24022 17.5 7.36739 17.5 7.5V11.1687C17.5 16.4187 13.0437 18.1562 12.1562 18.45C12.0554 18.4873 11.9446 18.4873 11.8438 18.45C10.9563 18.1562 6.5 16.4187 6.5 11.1687Z",
    fill: "#6000E9",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4011 18.3689C10.4011 18.3689 11.0601 18.7165 11.6795 18.9223C11.6795 18.9223 12 19.0376 12.3205 18.9223C12.3205 18.9223 12.9399 18.7165 13.5989 18.3689C13.5989 18.3689 14.6583 17.81 15.4995 17.0359C15.4995 17.0359 18 14.7347 18 11.1687V7.5C18 7.5 18 7.08579 17.7071 6.79289C17.7071 6.79289 17.4142 6.5 17 6.5H7C7 6.5 6.58579 6.5 6.29289 6.79289C6.29289 6.79289 6 7.08579 6 7.5V11.1687C6 11.1687 6 14.7347 8.50048 17.0359C8.50048 17.0359 9.34168 17.81 10.4011 18.3689ZM13.1323 17.4844C13.1323 17.4844 12.5435 17.7951 12 17.975C12 17.975 11.4565 17.7951 10.8677 17.4844C10.8677 17.4844 9.92322 16.9862 9.17765 16.3001C9.17765 16.3001 7 14.296 7 11.1687V7.5H17V11.1687C17 11.1687 17 14.296 14.8224 16.3001C14.8224 16.3001 14.0768 16.9862 13.1323 17.4844Z",
    fill: "#6000E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59544 11.8885C9.50241 11.7996 9.37868 11.75 9.25 11.75C9.24989 11.75 9.23866 11.7501 9.23866 11.7501C9.10608 11.7531 8.98014 11.8087 8.88852 11.9046C8.79961 11.9976 8.75 12.1213 8.75 12.25L8.75013 12.2613C8.75314 12.3939 8.80869 12.5199 8.90456 12.6115L10.7358 14.3615C10.929 14.5461 11.2331 14.5462 11.4264 14.3618L15.095 10.8619L15.0951 10.8618C15.1911 10.7702 15.2467 10.6443 15.2499 10.5118C15.2501 10.5038 15.25 10.4957 15.2498 10.4877C15.2468 10.3635 15.1976 10.2448 15.1118 10.1549C15.0174 10.056 14.8867 10 14.75 10L14.7359 10.0002C14.6123 10.0037 14.4943 10.0529 14.4049 10.1382L14.4047 10.1383L11.0815 13.3087L9.59544 11.8885Z",
    fill: "#6000E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.9f0e79a1ca8ba051179a36f9cd6ccdf0.svg";
export { ForwardRef as ReactComponent };